import React from "react";
import styles from "./auth_style.module.css";
import { checkIfChristmasPeriod } from "../../utils/checkIfChristmasPeriod";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { SCHOOL_DETAILS } from "../../utils/constants";

export default function AuthPageWrapper({ children }) {
	return (
		<div
			className={`${styles.auth_container} d-flex flex-column gap-5 justify-content-center text-center align-items`}
		>
			<div className={`${styles.auth_card} bg-white`}>
				{checkIfChristmasPeriod() && (
					<div className={styles.christmasLightContainer}>
						<img
							src={SCHOOL_DETAILS.christmasLight}
							alt="chrsitmas Light"
							className={`${styles.light}`}
						/>
					</div>
				)}
				<div className={`mt-5 pt-2 ${styles.logo}`}>
					<Link to="/">
						<img
							src={
								checkIfChristmasPeriod()
									? SCHOOL_DETAILS.christmasLogoSingle
									: SCHOOL_DETAILS.loginLogo
							}
							alt={SCHOOL_DETAILS.shortForm + " Logo"}
							className={`${styles.loginLogo}`}
						/>
					</Link>
				</div>
				{children}
			</div>
		</div>
	);
}
